export default {"src":"/_next/static/media/mountain-conditions-report.53eb9c41.svg","height":34,"width":24,"blurWidth":0,"blurHeight":0};